import {IAlertValues} from "../actions/add_remove_alert_action";
import {AlertType} from "./AlertType";

export const alertFetchDataError: IAlertValues = {type: AlertType.ERROR, text: "Wystąpił problem przy ładowaniu danych. Spróbuj ponownie."};
